import { CssBaseline } from '@mui/material';
import React from 'react';

import Loading from './common/components/loading';
import WarningModal from './common/components/warningModal';
import MainRouter from './infra/routing';
import ThemeProviderWrapper from './infra/theme';

const App = () => {
  return (
    <ThemeProviderWrapper>
      <CssBaseline />
      <WarningModal />
      <Loading />
      <MainRouter />
    </ThemeProviderWrapper>
  );
};

export default App;
